import React, { useState } from "react";
import PropTypes from "prop-types";
import { AsyncCombobox } from "@sainsburys-tech/fable";

const ZoneMultiSelector = props => {
  const [selectedItems, setSelectedItems] = useState(
    props.defaultSelectedOptions.map(zone => ({
      label: zone.name,
      value: zone.zoneRef
    }))
  );

  const mapZones = zones =>
    zones.map(zone => {
      return {
        label: zone.name,
        value: zone.zoneRef
      };
    });

  const mapSelectorZones = selectorZones =>
    selectorZones.map(selectorZone =>
      props.zones.find(zone => zone.zoneRef === selectorZone.value)
    );

  const handleSelection = selectedZones => {
    const zones = mapSelectorZones(selectedZones);
    setSelectedItems(selectedZones);
    props.onSelect(zones);
  };

  const fetchOptions = async () => {
    return mapZones(props.zones);
  };

  return (
    <AsyncCombobox
      name="zone-multi-selector"
      label={props.label}
      placeholder={props.placeholder}
      options={fetchOptions}
      value={selectedItems}
      defaultValue={mapZones(props.defaultSelectedOptions)}
      onChange={handleSelection}
      isMultiSelect={true}
      isDisabled={props.disabled}
    />
  );
};

ZoneMultiSelector.propTypes = {
  zones: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      zoneRef: PropTypes.string.isRequired
    })
  ).isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  defaultSelectedOptions: PropTypes.array,
  disabled: PropTypes.bool
};

ZoneMultiSelector.defaultProps = {
  label: "Zones",
  placeholder: "Add zone(s)",
  defaultSelectedOptions: [],
  disabled: false
};

export default ZoneMultiSelector;
